import React, { useEffect, useState } from 'react';

import api from '../../api/';
import apifunctions from '../../api/functions.js';
import functions from '../../functions';
import Modal from "./Modal.js"
import {
  Row, Col, Collapse,
  Card, CardBody, CardTitle, Button,
} from 'reactstrap';
import ParadigmaTable from "../../components/ParadigmaTable/"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/"
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/"
import MargenInput from './MargenInput';
import ButtonExport from './ButtonExport';
import Loader from '../../components/Loader/Loader';

const lista_default = {
  Codigo: "000001",
  NombreCompleto: "Venta Básico"
};

const initialColumns = [
  {
    Header: "id",
    id: "id",
    accessor: "id",
    show: false,
    private: true,
  },
  {
    Header: "Código",
    id: "Codigo",
    accessor: d => d.Codigo,
    className: "text-center",
    show: true,
    width: 100,
  },
  {
    Header: "Descripción",
    id: "Titulo",
    accessor: d => d.Titulo,
    lookup: '*',
    show: true,
  },
  {
    Header: "Precio",
    id: "precio_en_lista",
    width: 100,
    className: "text-right",
    accessor: d => `$ ${functions.FormatPrice(d.precio_en_lista)}`,
    show: true,
  },
  {
    Header: "Stock",
    id: "stockTotal",
    className: "text-right",
    width: 100,
    accessor: d => d.stockTotal,
    show: true,
  },
  {
    Header: "Proveedor",
    id: "ProveedorNombre",
    className: "text-right",
    width: 100,
    accessor: d => {return d.ProveedorNombre},
    show: true,
  },
];

const columnMargen = (margen) => {

  let porcentaje = 1 + margen / 100;

  return {
    Header: "Precio + %",
    width: 110,
    className: "text-right",
    Cell: d => `$ ${functions.FormatPrice(d.original.precio_en_lista * porcentaje)}`,
    show: true,
  }
}

const addColumnMargen = (columns, margen) => {

  let newColumns = [...columns];
  let columnStock = newColumns.pop();
  newColumns.push(columnMargen(margen));
  newColumns.push(columnStock);

  return newColumns;
}

const useFilters = () => {
  const [state, setState] = useState({
    rubro_id: null,
    linea_id: null,
    grupo_id: null,
    marca_id: null,
    proveedor_id: null,
  });

  const [outerFilter, setOuterFilter] = useState([{ id: "DeBaja", lookup: "exact", value: "False" }]);

  useEffect(() => {
    const _outerFilter = [{ id: "DeBaja", lookup: "exact", value: "False" }];
    if (state.proveedor_id != undefined && state.proveedor_id != null) {
      _outerFilter.push({
        id: 'Proveedor_id',
        value: {
          lookup: 'exact',
          input: state.proveedor_id
        },
      });
    }
    if (state.marca_id != undefined && state.marca_id != null) {
      _outerFilter.push({
        id: 'Marca_id',
        value: {
          lookup: 'exact',
          input: state.marca_id
        },
      });
    }
    if (state.linea_id != undefined && state.linea_id != null) {
      _outerFilter.push({
        id: 'Linea_id',
        value: {
          lookup: 'exact',
          input: state.linea_id
        },
      });
    }
    if (state.rubro_id != undefined && state.rubro_id != null) {
      _outerFilter.push({
        id: 'Rubro_id',
        value: {
          lookup: 'exact',
          input: state.rubro_id
        },
      });
    }
    if (state.grupo_id != undefined && state.grupo_id != null) {
      _outerFilter.push({
        id: 'Grupo_id',
        value: {
          lookup: 'exact',
          input: state.grupo_id
        },
      });
    }
    setOuterFilter(_outerFilter);
  }, [state]);


  return {
    outerFilter,
    filters: state,
    updateFilters: (filter) => setState({ ...state, ...filter }),
  }
}

const sort = [{ id: 'Titulo', desc: false }];

const FUAInitialState = { isDeprecated: true, FUA: new Date(-8640000000000000) };

const initialMargen = { show: false, margen: 0 }

const ConsultadorArticulos = (props) => {
  const { modernTheme } = props;

  const [columns, setColumns] = useState(initialColumns);
  const [listas, setListasDePrecios] = useState([]);
  const [currentLista, setCurrentLista] = useState(lista_default);
  const [FUAState, setFUAState] = useState(FUAInitialState);
  const [margenState, setMargenState] = useState(initialMargen);

  const [loading, setLoading] = useState(false);
  
  useEffect(() => getListas(), []);
  useEffect(() => getFechaModificacion(), []);
  useEffect(() => getConfigConsultador(), []);
  useEffect(() => changeColumn(), [margenState]);

  // const cambiarEstado=()=>{
  //   setLoading(false);
  //   setTimeout(()=>{
  //     setLoading(false);
  //   }, 5000)
  // }

  const getListas = (reintento = 0) => {
    const successCallback = (response) => {
      setListasDePrecios(response.data ? response.data : []);
      setCurrentLista(
        response.data && response.data.length > 0 ? (
          response.data.some(l => l.Codigo == lista_default.Codigo)
            ? response.data.filter(l => l.Codigo == lista_default.Codigo)[0]
            : response.data[0]
        ) : (
          ""
        ));
    }
    const failureCallback = () => {
      if (reintento > 3) {
        setListasDePrecios([]);
        setCurrentLista("");
      }
      else getAndProcess(reintento + 1);
    };
    const params = { filters: ["Codigo[not]=000000"], fields: ['NombreCompleto', 'Codigo'] };
    apifunctions.get(api.consultador.listasDePrecios, null, null, params, successCallback, failureCallback, failureCallback);
  }

  const getConfigConsultador = (reintento = 0) => {
    const successCallback = (response) => {
      let margen = parseFloat(response.data.margen);
      if (margen > 0) {
        setMargenState({ margen: margen, show: true });
      }
    }
    const failureCallback = () => {
      if (reintento < 3) {
        getConfigConsultador(reintento + 1);
      }
    };
    apifunctions.get(api.consultador.configConsultador, null, null, {}, successCallback, failureCallback, failureCallback);
  }

  const getFechaModificacion = (reintento = 0) => {
    const successCallback = (response) => {
      setFUAState(response.data ? response.data : { ...FUAInitialState });
    }
    const failureCallback = () => {
      if (reintento > 3) setFUAState(FUAInitialState);
      else getAndProcess(reintento + 1);
    };
    apifunctions.get(api.gestion.fechaUltimaModificacion, null, null, {}, successCallback, failureCallback, failureCallback);
  }

  const changeColumn = () => {
    if (margenState.show) {
      let newColumns = addColumnMargen(initialColumns, margenState.margen);
      setColumns(newColumns);
    } else {
      setColumns(initialColumns);
    }
  }

  const { outerFilter, updateFilters, filters } = useFilters();

  const [showFilters, setShowFilters] = useState(false);

    return (
      <Row className="container-fluid-modif consultador-articulos-web">
        <Col xs={12}>
          <Row className="w-100">
            <Col xs={6} md={8} lg={4} className="my-auto">
              <ParadigmaLabeledInput
                clearable={false}
                disabled={false}
                md={[3, 9]}
                classNames={["", "my-auto"]}
                label={"Lista de Precio:"}
                inputComponent={
                  <ParadigmaAsyncSeeker
                    clearable={false}
                    disabled={false}
                    value={currentLista.Codigo}
                    valueField={'Codigo'}
                    displayField={'NombreCompleto'}
                    onChange={data => setCurrentLista(data ? data : lista_default)}
                    optionDefault={listas}
                  />}
              />
            </Col>
            <Col xs={4} md={4} lg={4} className="my-auto d-none d-lg-block">
              <MargenInput
                setMargen={(m) => setMargenState({ ...margenState, margen: m })}
                margen={margenState.margen}
                setShowMargen={(s) => setMargenState({ ...margenState, show: s })}
                showMargen={margenState.show}
              />
            </Col>
            <Col className="my-auto p-2 text-right ml-auto" xs={4} lg={4}>
              <div className="">Ultima Actualización: <strong>{functions.FormatDate(FUAState.FUA)}</strong></div>
              {
                FUAState.isDeprecated &&
                <div><small><strong className="bg-danger px-2 rounded">INFORMACIÓN MUY ANTIGUA</strong></small></div>
              }
            </Col>
          </Row>
        </Col>
        <Col xs={12} className="d-none d-lg-block">
          <Row className="mb-2">
            <Col className="col-12">
              <Card body className="border-0 p-0 m-0">
                <CardTitle className="text-center py-2 mb-0 col-color">
                  <Button color="primary" className="w-100 btn-sm" onClick={() => setShowFilters(!showFilters)}>
                    + Filtros
                  </Button>
                </CardTitle>
                <Collapse isOpen={showFilters}>
                  <CardBody className="p-1 border rounded">
                    <Row>
                      <Col xs={12} md={6}>
                        <ParadigmaLabeledInput
                          label="Grupos"
                          md={[2, 10]}
                          inputComponent={
                            <ParadigmaAsyncSeeker
                              url={api.gestion.articulos.grupos}
                              value={filters.grupo_id}
                              displayField="Nombre"
                              valueField="Codigo"
                              parameters={{
                                paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                              }}
                              onChange={data => updateFilters({ grupo_id: data ? data.Codigo : null })}
                            />
                          }
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <ParadigmaLabeledInput
                          label="Rubros"
                          md={[2, 10]}
                          inputComponent={
                            <ParadigmaAsyncSeeker
                              url={api.gestion.articulos.rubros}
                              value={filters.rubro_id}
                              displayField="Nombre"
                              valueField="Codigo"
                              parameters={{
                                paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                              }}
                              onChange={data => updateFilters({ rubro_id: data ? data.Codigo : null })}
                            />
                          }
                        />
                      </Col>
                    </Row>
  
                    <Row>
                      <Col xs={12} md={6}>
                        <ParadigmaLabeledInput
                          label="Proveedores"
                          md={[2, 10]}
                          inputComponent={
                            <ParadigmaAsyncSeeker
                              url={api.gestion.articulos.proveedores}
                              value={filters.proveedor_id}
                              displayField="Nombre"
                              valueField="Codigo"
                              parameters={{
                                paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                              }}
                              onChange={data => updateFilters({ proveedor_id: data ? data.Codigo : null })}
                            />
                          }
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <ParadigmaLabeledInput
                          label="Marcas"
                          md={[2, 10]}
                          inputComponent={
                            <ParadigmaAsyncSeeker
                              url={api.gestion.articulos.marcas}
                              value={filters.marca_id}
                              displayField="Nombre"
                              valueField="Codigo"
                              parameters={{
                                paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                              }}
                              onChange={data => updateFilters({ marca_id: data ? data.Codigo : null })}
                            />
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={6}>
                        <ParadigmaLabeledInput
                          label="Lineas"
                          md={[2, 10]}
                          inputComponent={
                            <ParadigmaAsyncSeeker
                              url={api.gestion.articulos.lineas}
                              value={filters.linea_id}
                              displayField="Nombre"
                              valueField="Codigo"
                              parameters={{
                                paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                              }}
                              onChange={data => updateFilters({ linea_id: data ? data.Codigo : null })}
                            />
                          }
                        />
                      </Col>
                      <Col xs={12} md={6} />
                    </Row>
                  </CardBody>
                </Collapse>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col xs={12} className="tab-articulos">
          {currentLista && currentLista.Codigo != undefined && currentLista.Codigo != '' &&
            <ParadigmaTable
              key={"table" + currentLista.Codigo}
              modernTheme={modernTheme}
              buttons={[
                {
                  edit: true,
                  component: (props) => <Modal {...props} action="DETAIL" lista_code={currentLista.Codigo} />,
                  permission: 'consultadorarticulos_detail',
                }, {
                  edit: true,
                  component: (props) =>
                    <ButtonExport
                      url={`${api.consultador.articulos}/${currentLista.Codigo}/export/`}
                      fileName={"Articulos.xls"}
                    />,
                  permission: 'consultadorarticulos_detail',
                },
                {
                  edit: true,
                  component: (props) =>
                    <ButtonExport
                      url={`${api.consultador.articulos}/exportcsv/`}
                      // fileName={"articulos.csv"}
                      fileName={"articulos.xlsx"}
                      loading={loading}
                    />,
                  permission: 'consultadorarticulos_detail',
                },
              ]}
              apiUrl={`${api.consultador.articulos}/${currentLista.Codigo}/`}
              columns={columns}
              title={"Artículos"}
              defaultPageSize={showFilters ? 15 : 20}
              outerFilter={outerFilter}
              outerSort={sort}
            />
          }
        </Col>
      </Row>
    );
  }

export default ConsultadorArticulos;



// WEBPACK FOOTER //
// ./src/views/ConsultadorArticulos/ConsultadorArticulos.js